import { Application } from '@hotwired/stimulus';
import { Autocomplete } from 'stimulus-autocomplete';
import { appsignal } from '../../appsignal';
import { installErrorHandler } from '@appsignal/stimulus';

const application = Application.start();
application.register('autocomplete', Autocomplete);
installErrorHandler(appsignal, application);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import EatmsController from '../eatms_controller';
application.register('eatms', EatmsController);

import GalleryController from './gallery_controller';
application.register('gallery', GalleryController);

import GalleryStripController from './gallery_strip_controller';
application.register('gallery-strip', GalleryStripController);

import HeadlineMarkerController from './headline_marker_controller';
application.register('headline-marker', HeadlineMarkerController);

import ScrollTopButtonController from './scroll_top_button_controller';
application.register('scroll-top-button', ScrollTopButtonController);

import TabsController from './tabs_controller';
application.register('tabs', TabsController);

import TeaserRowController from './teaser_row_controller';
application.register('teaser-row', TeaserRowController);

import ToastController from './toast_controller';
application.register('toast', ToastController);

import JobsFiltersController from './jobs_filters_controller';
application.register('jobs-filters', JobsFiltersController);

import FactorialIframeController from './factorial_iframe_controller';
application.register('factorial-iframe', FactorialIframeController);

import GoogleFormController from './google_form_controller';
application.register('google-form', GoogleFormController);

import GoogleFormStarsController from './google_form_stars_controller';
application.register('google-form-stars', GoogleFormStarsController);

import StudioBrowserController from './studio_browser_controller';
application.register('studio-browser', StudioBrowserController);

import StudioFinderController from './studio_finder_controller';
application.register('studio-finder', StudioFinderController);
